/* eslint-disable */
export default {
  order: 4,
  header: [],
  content: [
    {
      category: '2.4 Release Notes (2023/02/27)',
      description: 'Check out EnOS release notes.',
      url: '',
      isVersionInfo: true,
      item: [
        {
          name: 'EnOS Cloud 2.4 Cumulative Updates',
          description: 'A cumulative update is a quarterly update that includes new features, enhancements, and issue fixes.',
          image: '',
          list: [
            {
              name: '2.4 Cumulative Update 3',
              url: '/docs/enos/en/2.4.0/releasenotes/cu3.html'
            },
            {
              name: '2.4 Cumulative Update 2',
              url: '/docs/enos/en/2.4.0/releasenotes/cu2.html'
            },
            {
              name: '2.4 Cumulative Update 1',
              url: '/docs/enos/en/2.4.0/releasenotes/cu1.html'
            }
          ]
        },
        {
          name: 'EnOS Cloud 2.4',
          description: '',
          image: 'assets/images/EnOS_Cloud_RN.png',
          list: [
            {
              name: 'What’s New?',
              url: '/docs/enos/en/2.4.0/releasenotes/new_feature.html'
            },
            {
              name: 'What’s Changed?',
              url: '/docs/enos/en/2.4.0/releasenotes/enhancement.html'
            },
            {
              name: 'Deprecations and Removals',
              url: '/docs/enos/en/2.4.0/releasenotes/deprecated.html'
            },
            {
              name: 'Known Issues and Limitations',
              url: '/docs/enos/en/2.4.0/releasenotes/knownissue.html'
            }
          ]
        },
        {
          name: 'EnOS Edge 2.4',
          description: '',
          image: 'assets/images/Edge_RN.png',
          list: [
            {
              name: 'What’s New?',
              url: '/docs/enos-edge/en/2.4.0/releasenotes/new_feature_2.4.0.html'
            }
          ]
        }
      ]
    },
    {
      category: 'EnOS 101',
      description: 'EnOS provides core services based on AIoT technology from Univers that is missioned to enable enterprises and cities to accelerate digital transformation for low-carbon and ecosystem development.',
      image: 'assets/images/EnOS_101.png',
      url: '',
      item: [
        {
          name: 'EnOS Overview',
          description: 'Learn about the advantages and key concepts of EnOS.',
          image: 'assets/images/common-resource_bw.png',
          list: [
            {
              name: 'What is EnOS',
              url: '/docs/enos/en/2.4.0/overview/enos_introduction.html'
            },
            {
              name: 'EnOS Advantages',
              url: '/docs/enos/en/2.4.0/overview/advantage.html'
            },
            {
              name: 'Frequently Asked Questions',
              url: '/docs/enos/en/2.4.0/faq/index.html'
            }
          ]
        },
        {
          name: 'Getting Started',
          description: 'Learn about how to access EnOS and the key capabilities on EnOS.',
          image: 'assets/images/start.png',
          list: [
            {
              name: 'Accessing EnOS',
              url: '/docs/enos/en/2.4.0/get_started/accessing_enos.html'
            },
            {
              name: 'Application Enablement on EnOS',
              url: '/docs/enos/en/2.4.0/get_started/app.html'
            },
            {
              name: 'Device Connectivity and Management on EnOS',
              url: '/docs/enos/en/2.4.0/get_started/device.html'
            }
          ]
        }
      ]
    },
    {
      category: 'Tutorials',
      description: 'Explore step-by-step walkthroughs of AIoT scenarios.',
      image: 'assets/images/tutorial.png',
      url: '',
      item: [
        {
          name: 'Application Enablement',
          description: '',
          image: 'assets/images/app_bw.png',
          list: [
            {
              name: 'Onboarding a Solar Site and a Weather Station Device to EnOS',
              url: '/docs/onboarding-tool/en/2.4.0/tutorial/onboarding.html'
            },
            {
              name: 'Building a Smart Battery Dashboard',
              url: '/docs/dtv/en/2.4.0/tutorial/index.html'
            },
            {
              name: 'Building a Water Purification System Monitoring Page',
              url: '/docs/dtv/en/2.4.0/tutorial/monitor.html'
            },
            {
              name: 'Create and Close a Work Order',
              url: '/docs/wmt/en/2.4.0/tutorial/creating_and_completing_work_order.html'
            },
            {
              name: 'Developing Metrics of Solar Generation, Temperature, and Radiance',
              url: '/docs/metric-management/en/2.4.0/tutorial/index.html'
            },
            {
              name: 'Assessing the Data Qualities of Wind Turbine Devices ',
              url: '/docs/data-quality/en/2.4.0/tutorial.html'
            }
          ]
        },
        {
          name: 'Device Connectivity and Management',
          description: '',
          image: 'assets/images/IoT Hub_LIght.png',
          image: 'assets/images/device_bw.png',
          list: [

            {
              name: 'Connecting a Simulated Device to EnOS',
              url: '/docs/device-connection/en/2.4.0/tutorial/connecting_device_simulated/index.html'
            },
            {
              name: 'Connecting a Simulated Meter to EnOS Edge via IEC104 Protocol',
              url: '/docs/enos-edge/en/2.4.0/tutorial/connecting_edge.html'
            },
            {
              name: 'Setting Different Alert Thresholds for Devices of the Same Model',
              url: '/docs/alert/en/2.4.0/howto/set_alert_rule_for_device.html'
            },
            {
              name: 'Setting the Alert Triggering Delay Timer',
              url: '/docs/alert/en/2.4.0/howto/setting_alert_triggering_delay_timer.html'
            },
            {
              name: 'Setting a State-based Triggered Alert',
              url: '/docs/alert/en/2.4.0/howto/setting_state_based_alert.html'
            },
            {
              name: 'Plug-and-Play Raspberry Pi Onboarding',
              url: '/docs/device-provisioning/en/2.4.0/tutorials/pnp_raspberry_pi/index.html'
            },
            {
              name: 'Reprovisioning Device',
              url: '/docs/device-provisioning/en/2.4.0/tutorials/reprovisioning/index.html'
            },
            {
              name: 'Replacing Device',
              url: '/docs/device-provisioning/en/2.4.0/tutorials/replacing_device/index.html'
            }
          ]
        },
        {
          name: 'Data Management and Analytics',
          description: '',
          image: 'assets/images/data_bw.png',
          list: [

            {
              name: 'PC Device Data Integration',
              url: '/docs/device-integration/en/2.4.0/howto/tutorial_pc_device_mgmt.html'
            },
            {
              name: 'Creating a Master Data Model and Relationship Model',
              url: '/docs/data-asset-catalog/en/2.4.0/tutorials/tutorial_1.html'
            },
            {
              name: 'Data Filtering and Calculation Using Tags',
              url: '/docs/data-asset-catalog/en/2.4.0/tutorials/tutorial_2.html'
            },      
            {
              name: 'Develop a Wind Power Prediction Model',
              url: '/docs/ai-analytics/en/2.4.0/tutorial/index.html'
            }
          ]
        }
      ]
    },
    {
      category: 'Application Enablement',
      image: 'assets/images/Application_Enablement_Platform_LIght.png',
      description: 'Provides toolkits, components, and services for application development, helping you to build, deploy, and extend applications easily.',
      image: 'assets/images/app_dev.png',
      url: '/docs/enos/en/2.4.0/get_started/app.html',
      messageTip: { 
        type: 'info',
        message: 'Tips',
        description: {
          type: 'link',
          content: [
            {
              text: 'Application Enablement Overview',
              url: '/docs/app-development/en/2.4.0/app_dev_overview.html'
            },
            {
              text: 'Creating Applications Using Industry Application Common Building Blocks',
              url: '/docs/app-development/en/2.4.0/app_dev_workflow/index.html'
            }
          ]
        }
      },
      item: [
        {
          name: 'Application Portal',
          description: 'A portal featured with flexible permission management and unified application access, which provides Role-Based Access Control (RBAC) system for organization administrators and smooth and convenient application access experience for end users. Integrated with EnOS services and data, Application Portal helps enterprises increase permission management efficiency and reduce application R&D cost.',
          image: 'assets/images/aep/Application_Portal.png',
          list: [
            {
              name: 'Application Portal Overview',
              url: '/docs/app-portal/en/2.4.0/overview.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/app-portal/en/2.4.0/concept.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/app-portal/en/2.4.0/start/setting_up_app_portal.html'
            },
            {
              name: 'Application Portal API',
              url: '/docs/app-portal-api/en/2.4.0/overview.html'
            }
          ]
        },
        {
          name: 'Common Data Service',
          description: 'Unified API service providing one-stop data access by allowing the registration of data source API to CDS under the defined API standards. The available data types include asset information, points, attributes, metrics, and records, which are also configurable in CDS based on the runtime calculation capability.',
          image: 'assets/images/aep/Common_Data_Service.png',
          list: [
            {
              name: 'Common Data Service Overview',
              url: '/docs/cds/en/2.4.0/overview.html'
            },
            {
              name: 'Setting up Common Data Service',
              url: '/docs/cds/en/2.4.0/getstarted/setup.html'
            },
            {
              name: 'Common Data Service API',
              url: '/docs/cds-app-api/en/2.4.0/overview.html'
            }
          ]
        },
        {
          name: 'Onboarding Tool',
          description: 'A one-stop asset onboarding tool for asset administrators to batch onboard and manage massive numbers and different types of industrial assets.',
          image: 'assets/images/onboarding.png',
          list: [
            {
              name: 'Onboarding Tool Overview',
              url: '/docs/onboarding-tool/en/2.4.0/learn/onboarding_tool_overview.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/onboarding-tool/en/2.4.0/learn/quickstarts.html'
            },
            {
              name: 'Onboarding Tool API',
              url: '/docs/onboarding-tool-api/en/2.4.0/overview.html'
            }
          ]
        },
        {
          name: 'Unified Monitoring',
          description: 'A one-stop monitoring configuration center with diversified cross-domain monitoring abilities. Unified Monitoring empowers delivery team to quickly build multi-domain monitoring pages and enables end users to visualize various asset status and metrics in multiple visualization types such as maps, lists, charts, reports, etc. Using Unified Monitoring to monitor massive assets in multiple domains, enterprises can boost development efficiency on monitoring pages and reduce cycle times in projects. ',
          image: 'assets/images/aep/monitoring.png',
          list: [
            {
              name: 'Unified Monitoring Overview',
              url: '/docs/monitor/en/2.4.0/overview/monitor_overview.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/monitor/en/2.4.0/overview/key_concepts.html'
            },
            {
              name: 'Exploring Unified Monitoring',
              url: '/docs/monitor/en/2.4.0/get_started/explore.html'
            }
          ]
        },
        {
          name: 'Digital Twin Visualization',
          description: 'Digital Twin Visualization is a model-based and low-code application development tool for data visualization. The built-in rich graphic widgets and flexible configuration capabilities empower civilian developers to build visual applications and greatly improve development efficiency. You can use a combination of 2D and 3D technologies to enhance the user experience of your monitoring and operation applications.',
          image: 'assets/images/aep/Digital_Twin_Visualization.png',
          list: [
            {
              name: 'Digital Twin Visualization Overview',
              url: '/docs/dtv/en/2.4.0/overview.html'
            },
            {
              name: 'Managing Projects and Pages in Digital Twin Dashboard',
              url: '/docs/dtv/en/2.4.0/building_dashboard/managing_project_pages.html'
            },
            {
              name: 'Widgets in Digital Twin Dashboard',
              url: '/docs/dtv/en/2.4.0/reference/widgets/index.html'
            },
            {
              name: 'Using Panels in Digital Twin Monitoring ',
              url: '/docs/dtv/en/2.4.0/building_m&c_panel/managing_panel.html'
            }
          ]
        },
        {
          name: 'Alarm Management',
          description: 'A tool that manages the entire lifecycle of alarms. By configuring alarm triggering rules, notification rules, and response rules, the abnormal conditions during the operation of devices can be easily identified and informed to relevant personnel by Alarm Management, which enables the  exceptions to be dealt with timely and effectively. Enterprises cost reduction and efficiency increase in operation and management can be also realized by using Alarm Management to improve the stability of device operation.',
          image: 'assets/images/alarm.png',
          list: [
            {
              name: 'Alarm Management Overview',
              url: '/docs/alarm-management/en/2.4.0/overview/about.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/alarm-management/en/2.4.0/overview/key_concepts.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/alarm-management/en/2.4.0/getting_started/quick_start.html'
            }
          ]
        },
        {
          name: 'Work Management',
          description: 'An end-to-end work order ​management tool covering both Web and Mobile seamlessly integrates with EnOS M&C and Advanced Analytics applications for closed-loop alarm handling and daily task management. The powerful Connector simplifies the integration with third-party CMMS/EAM.',
          image: 'assets/images/workmanagement.png',
          list: [
            {
              name: 'Work Management Overview',
              url: '/docs/wmt/en/2.4.0/about.html'
            },
            {
              name: 'Creating Work Orders',
              url: '/docs/wmt/en/2.4.0/howto/creating_work_order.html'
            },
            {
              name: 'Work Management API',
              url: '/docs/wmt-api/en/2.4.0/overview.html'
            }
          ]
        },
        {
          name: 'Reporting Tool',
          description: 'An EnOS-based lightweight reporting tool that provides one-stop report building and management capabilities to customize report templates and to generate, subscribe to, preview, and download reports. It empowers enterprises and organizations to design reports with no code and manage daily report management tasks effortlessly.',
          image: 'assets/images/aep/Reporting_Tool.png',
          list: [
            {
              name: 'Reporting Tool Overview',
              url: '/docs/reporting/en/2.4.0/overview.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/reporting/en/2.4.0/concept.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/reporting/en/2.4.0/getstarted/quickstart.html'
            }
          ]
        },
        {
          name: 'Fleet Control',
          description: 'Fleet Control provides out-of-the-box control services for domain applications including the accumulation of control capabilities based on industry standards as well as open and user-defined control panels, which are compatible with a wide range of control scenarios and can be trusted for secure and compliant control operations. With Fleet Control, enterprises can quickly and cost-effectively develop control applications.',
          image: 'assets/images/aep/Fleet_Control.png',
          list: [
            {
              name: 'Fleet Control Overview',
              url: '/docs/control/en/2.4.0/overview.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/control/en/2.4.0/concept.html'
            },
            {
              name: 'Exploring Control Panel',
              url: '/docs/control/en/2.4.0/getstarted/panel_explore.html'
            }
          ]
        },
        {
          name: 'Metric Management',
          description: 'Integrates metric standardization definition, metric configuration calculation, and metric multi-source query service to build a unified, convenient, safe, and efficient metric system platform for enterprises.',
          image: 'assets/images/metric.png',
          list: [
            {
              name: 'Metric Management Overview',
              url: '/docs/metric-management/en/2.4.0/overview/metrics_overview.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/metric-management/en/2.4.0/overview/metrics_concept.html'
            },
            {
              name: 'Managing Metrics',
              url: '/docs/metric-management/en/2.4.0/howto/metric.html'
            },
            {
              name: 'Metric Management API',
              url: '/docs/metric-api/en/2.4.0/overview.html'
            }
          ]
        },
        {
          name: 'Data Quality',
          description: 'Monitors the qualities of real-time data from three quality dimensions of Completeness, Validity, and Timeliness based on the configurable quality rules to help enterprises easily assess data qualities by the visual quality dashboard and reports.',
          image: 'assets/images/dq.png',
          list: [
            {
              name: 'Data Quality Overview',
              url: '/docs/data-quality/en/2.4.0/overview/about.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/data-quality/en/2.4.0/overview/key_concept.html'
            },
            {
              name: 'Configuring Assessment Rules',
              url: '/docs/data-quality/en/2.4.0/howto/rule.html'
            },
            {
              name: 'Viewing Data Qualities',
              url: '/docs/data-quality/en/2.4.0/howto/quality_dashboard.html'
            }
          ]
        },
        {
          name: 'DevOps',
          description: 'Built on DevOps best practices, the Developer Studio offers a compilation of the best tools to help simplify the application development, deployment, maintenance, and scaling process, thereby enabling efficient and seamless collaboration among application developers and operators.',
          image: 'assets/images/aep/Developer_Studio.png',
          list: [
            {
              name: 'DevOps Overview',
              url: '/docs/app-development/en/2.4.0/developer_studio/devops/devops.html'
            },
            {
              name: 'Managing Pipelines',
              url: '/docs/app-development/en/2.4.0/developer_studio/devops/pipeline/pipeline.html'
            },
            {
              name: 'Publishing Applications',
              url: '/docs/app-development/en/2.4.0/developer_studio/devops/publishing_app/publishing_app.html'
            }
          ]
        },
        {
          name: 'App Hub',
          description: 'Based on Helm Charts, common and reusable components and services can be deployed as templates in just a few clicks.',
          image: 'assets/images/aep/Application_Hosting.png',
          list: [
            {
              name: 'App Hub Overview',
              url: '/docs/app-development/en/2.4.0/developer_studio/app_hub/index.html'
            },
            {
              name: 'Creating Chart and publish to the App Hub',
              url: '/docs/app-development/en/2.4.0/developer_studio/gettingstarted_app.html'
            },
            {
              name: 'Managing Application Templates',
              url: '/docs/app-development/en/2.4.0/developer_studio/app_hub/managing_app_template.html'
            },
            {
              name: 'Deploying Application Instances',
              url: '/docs/app-development/en/2.4.0/developer_studio/app_hub/deploying_app_instance.html'
            }
          ]
        },
        {
          name: 'Functions',
          description: 'An event-driven function computing service, where resources are allocated and scheduled on a function-level basis so that functions can run in a flexible and reliable manner, thereby enabling you to focus on the business logic of your applications during development.',
          image: 'assets/images/aep/Serverless.png',
          list: [
            {
              name: 'Functions Overview',
              url: '/docs/app-development/en/2.4.0/developer_studio/functions/serverless_overview.html'
            },
            {
              name: 'Publishing a Function Application',
              url: '/docs/app-development/en/2.4.0/developer_studio/functions/managing_function.html'
            }
          ]
        },
        {
          name: 'Notification Management',
          description: 'Provides a user-oriented push messaging service that helps you manage messaging service accounts and quotas, allowing you to send push notifications, SMS, and emails to users for constant user interaction.',
          image: 'assets/images/edp/Data_Subscription.png',
          list: [
            {
              name: 'Notification Management Overview',
              url: '/docs/notification-mgmt/en/2.4.0/notification_center_overview.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/notification-mgmt/en/2.4.0/notification_gettingstarted.html'
            },
            {
              name: 'Notification Management API ',
              url: '/docs/notification-mgmt-api/en/2.4.0/overview.html'
            }
          ]
        },
        {
          name: 'API Management',
          description: 'Provides secured API life cycle management capabilities to help you grow your business quickly through API integrations.',
          image: 'assets/images/aep/API_Management.png',
          list: [
            {
              name: 'API Management Overview',
              url: '/docs/apim/en/2.4.0/api_management_overview.html'
            },
            {
              name: 'API Lifecycle Management',
              url: '/docs/apim/en/2.4.0/api_lifecycle_management.html'
            },
            {
              name: 'EnOS APIM Security',
              url: '/docs/apim/en/2.4.0/apim_security.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/apim/en/2.4.0/learn/api_management_quickstart.html'
            }
          ]
        },
        {
          name: 'EnOS API',
          description: 'APIs and API references are available for all EnOS core business processes, helping to expedite application development and access to system resources.',
          image: '',
          list: [
            {
              name: 'EnOS API Overview',
              url: '/docs/api/en/2.4.0/overview.html'
            },
            {
              name: 'API Authentication',
              url: '/docs/api/en/2.4.0/authen_overview.html'
            },
            {
              name: 'Get Started with EnOS API',
              url: '/docs/api/en/2.4.0/gettingstarted.html'
            }
          ]
        }
      ]
    },
    {
      category: 'Device Connectivity and Management',
      description: 'Provides extensive, secure, and fast connection to heterogeneous sensors, devices, and systems, and device life cycle management.',
      image: 'assets/images/device.png',
      item: [
        {
          name: 'Device Connectivity & Management Service',
          description: 'Rapidly access and manage the real-time or historical data of a vast number of diverse devices or systems. The built-in digital twin model library helps to expedite the digital abstraction of industry devices. Manage the entire device life cycle and set up dynamic alert triggers to reduce response time for device anomalies and faults.',
          image: 'assets/images/iothub/Connectivity.png',
          list: [
            {
              name: 'Device Connectivity Service Overview',
              url: '/docs/device-connection/en/2.4.0/device_management_overview.html'
            },
            {
              name: 'Device Modeling',
              url: '/docs/device-connection/en/2.4.0/howto/model/index.html'
            },
            {
              name: 'API Reference',
              url: '/docs/device-connection/en/2.4.0/reference/api_reference'
            }
          ]
        },
        {
          name: 'Alert Engine',
          description: 'A service that provides alert engine capabilities for O&M teams to proactively detect anomalies early and notify users quickly by defining, receiving, and processing alerts for organization assets, satisfying business needs such as real-time monitoring and asset fault analysis.',
          image: 'assets/images/Alert.png',
          list: [
            {
              name: 'Alert Engine Overview',
              url: '/docs/alert/en/2.4.0/learn/alert_overview.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/alert/en/2.4.0/howto/gettingstarted.html'
            },
            {
              name: 'Alert Engine API',
              url: '/docs/alert-api/en/2.4.0/overview.html'
            }
          ]
        },
        {
          name: 'Device Provisioning Service',
          description: 'A service that helps to simplify and achieve zero-touch IoT device onboarding through simple and fast configurations, enabling the scalable and secure provisioning of devices.',
          image: 'assets/images/dps.png',
          list: [
            {
              name: 'Device Provisioning Service Overview',
              url: '/docs/device-provisioning/en/2.4.0/overview/about.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/device-provisioning/en/2.4.0/getting_started/device_provisioning.html'
            },
            {
              name: 'Device Provisioning Service API',
              url: '/docs/dps-api/en/2.4.0/overview.html'
            }
          ]
        },
        {
          name: 'EnOS Edge',
          description: 'EnOS Edge is an intelligent software-defined IoT gateway and edge computing platform that adapts to heterogeneous devices and systems in the physical world and enables cost-effective IoT connectivity, edge computing, local control and optimization solutions.',
          image: 'assets/images/edge/user.png',
          list: [
            {
              name: 'EnOS Edge Overview',
              url: '/docs/enos-edge/en/2.4.0/edge_overview.html'
            },
            {
              name: 'Application Development',
              url: '/docs/enos-edge/en/2.4.0/howto/developer_guide/app_dev_overview.html'
            },
            {
              name: 'EnOS Edge API',
              url: '/docs/edge-api/en/2.4.0/index.html'
            }
          ]
        }
      ]
    },
    {
      category: 'Data Management and Analytics',
      image: 'assets/images/data.png',
      description: 'Explore the value of data assets, reduce your cost of massive IoT data ownership, and realize the efficient management of device asset data.',
      item: [
        {
          name: 'Device Data Integration Service',
          description: 'The low-code and intuitive drag-and-drop flow designer helps to accelerate the device integration process. You can also monitor the processes and set up alert notifications to reduce operation costs.',
          image: 'assets/images/iothub/Integration.png',
          list: [
            {
              name: 'Device Data Integration Service Overview',
              url: '/docs/device-integration/en/2.4.0/learn/device_integration_overview.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/device-integration/en/2.4.0/howto/gettingstarted_storing_data.html'
            },
            {
              name: 'Node Reference',
              url: '/docs/device-integration/en/2.4.0/reference/index_nodes.html'
            }
          ]
        },
        {
          name: 'Data Source Registration',
          description: 'Enables centralized registration of internal EnOS data sources and external data sources, so that related product modules can directly access these data sources.',
          image: 'assets/images/datasourceregistration.png',
          list: [
            {
              name: 'Data Source Registration Overview',
              url: '/docs/data-source-reg/en/2.4.0/datasource_overview.html'
            },
            {
              name: 'Registering a MySQL or SQL Server Data Source',
              url: '/docs/data-source-reg/en/2.4.0/connecting_mysql.html'
            }
          ]
        },
        {
          name: 'Data Synchronization',
          description: 'Establish the data transmission channel between external databases and EnOS internal databases to achieve the centralized synchronization and sharing of data and files.',
          image: 'assets/images/edp/Data_Synchronization.png',
          list: [
            {
              name: 'Data Synchronization Overview',
              url: '/docs/data-sync/en/2.4.0/di_overview.html'
            },
            {
              name: 'Synchronizing Data from External Data Source to Hive (Manual Scheduling)',
              url: '/docs/data-sync/en/2.4.0/creating_scratch_onetime.html'
            },
            {
              name: 'Synchronizing Data from External Data Source to Hive (Periodic Scheduling)',
              url: '/docs/data-sync/en/2.4.0/creating_scratch_hive2mysql.html'
            }
          ]
        },
        {
          name: 'Data Federation',
          description: 'A unified data access layer built on top of multi-source heterogeneous data storage systems without moving or synchronizing data. With Data Federation, different data consumers can access data rapidly by using the standard query methods, such as SQL, JDBC, or OData.',
          image: 'assets/images/edp/Data_Federation.png',
          list: [
            {
              name: 'Data Federation Overview',
              url: '/docs/data-federation/en/2.4.0/data_federation_overview.html'
            },
            {
              name: 'Channel Management',
              url: '/docs/data-federation/en/2.4.0/channel_management.html'
            },
            {
              name: 'Data Read and Write',
              url: '/docs/data-federation/en/2.4.0/data_rw.html'
            },
            {
              name: 'Data Federation API',
              url: '/docs/data-federation-api/en/2.4.0/overview.html'
            }
          ]
        },
        {
          name: 'Stream Processing',
          description: 'With the library of common calculators and templates that are accumulated from typical computing scenarios, you can easily develop stream processing and analysis pipelines in a low-code and intuitive drag-and-drop designer.',
          image: 'assets/images/edp/Stream_Processing.png',
          list: [
            {
              name: 'Stream Processing Overview',
              url: '/docs/stream-processing/en/2.4.0/streaming_overview.html'
            },
            {
              name: 'Developing Stream Processing Pipelines',
              url: '/docs/stream-processing/en/2.4.0/dev.html'
            },
            {
              name: 'Stream Processing Pipeline Operation',
              url: '/docs/stream-processing/en/2.4.0/ops.html'
            },
            {
              name: 'Stream Processing API',
              url: '/docs/stream-processing-api/en/2.4.0/overview.html'
            }
          ]
        },
        {
          name: 'Batch Data Processing',
          description: 'Enables data developers to process large amounts of data through a visual workflow designer and the stable scheduling service. You can perform calculations, analysis, and gain insights into your data based on data lakes, data warehouses, and application data.',
          image: 'assets/images/edp/Batch_Processing.png',
          list: [
            {
              name: 'Batch Data Processing Overview​',
              url: '/docs/batch-processing/en/2.4.0/dataide_overview.html'
            },
            {
              name: 'Task Resource Management',
              url: '/docs/batch-processing/en/2.4.0/job_resource/index.html'
            },
            {
              name: 'Workflow Development',
              url: '/docs/batch-processing/en/2.4.0/data_dev/index.html'
            },
            {
              name: 'Workflow Operation',
              url: '/docs/batch-processing/en/2.4.0/task_monitor/index.html'
            }
          ]
        },
        {
          name: 'Time Series Data Management',
          description: 'A high throughput, high availability, and high compression storage for massive IoT time series data.  The efficient query APIs and visualization tools help you identify and gain insights into your data.',
          image: 'assets/images/edp/Time_Series_Data_Management.png',
          list: [
            {
              name: 'Time Series Data Management Overview',
              url: '/docs/time-series-data/en/2.4.0/overview.html'
            },
            {
              name: 'Getting Started: Configuring Data Storage',
              url: '/docs/time-series-data/en/2.4.0/getting_started.html'
            },
            {
              name: 'Storage Policy for EnOS Cloud Users',
              url: '/docs/time-series-data/en/2.4.0/cloudpolicy/policy.html'
            },
            {
              name: 'Storage Policy for EnOS Edge Users',
              url: '/docs/time-series-data/en/2.4.0/edgepolicy/policy.html'
            },
            {
              name: 'Time Series Data Management API',
              url: '/docs/time-series-data/en/2.4.0/reference/api.html'
            }
          ]
        },
        {
          name: 'Data Subscription',
          description: 'Data subscriptions enable you to push data to applications in real time, improving the efficiency of data acquisition and consumption. Use the SDK provided to enable your applications to subscribe to data efficiently.',
          image: 'assets/images/edp/Data_Subscription.png',
          list: [
            {
              name: 'Data Subscription Overview',
              url: '/docs/data-subscription/en/2.4.0/data_subscription_overview.html'
            },
            {
              name: 'Getting Started: Subscribing to Real-time Data',
              url: '/docs/data-subscription/en/2.4.0/gettingstarted_subscribe_realtime.html'
            },
            {
              name: 'Getting Started: Subscribing to Basic Alert Data',
              url: '/docs/data-subscription/en/2.4.0/gettingstarted_subscribe_alerts.html'
            },
            {
              name: 'Consuming Subscribed Data for EnOS Cloud Users',
              url: '/docs/data-subscription/en/2.4.0/consuming_subscribed_data.html'
            },
            {
              name: 'Consuming Subscribed Data for EnOS Edge Users',
              url: '/docs/data-subscription/en/2.4.0/consuming_subscribed_data_edge.html'
            },
            {
              name: 'Data Subscription SDK Reference',
              url: '/docs/data-subscription/en/2.4.0/data_subscription_sdk.html'
            }
          ]
        },
        {
          name: 'Data Archiving',
          description: 'Massive data archiving is performed periodically to ensure that cold data, which is less frequently accessed and takes up a huge amount of storage, is stored in a more economical manner.',
          image: 'assets/images/edp/Data_Archiving.png',
          list: [
            {
              name: 'Data Archiving Overview',
              url: '/docs/data-archiving/en/2.4.0/archive_policy.html'
            },
            {
              name: 'Configuring Data Archiving Jobs',
              url: '/docs/data-archiving/en/2.4.0/configuring_archive_storage.html'
            },
            {
              name: 'Data Archiving Reference',
              url: '/docs/data-archiving/en/2.4.0/archive_storage.html'
            }
          ]
        },
        {
          name: 'Data Catalog',
          description: 'Provides comprehensive data governance of massive amounts of data from different sources, such as centralized classification and management of metadata, efficient querying, and data lineage tracking. Data Asset Catalog helps you to understand the data in your organization and achieve centralized management of data assets.',
          image: 'assets/images/edp/Data_Asset_Catalog.png',
          list: [
            {
              name: 'Data Catalog Overview',
              url: '/docs/data-asset-catalog/en/2.4.0/data_catalog_intro.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/data-asset-catalog/en/2.4.0/data_catalog_concept.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/data-asset-catalog/en/2.4.0/data_catalog_quickstart.html'
            },
            {
              name: 'Data Catalog API',
              url: '/docs/data-catalog-api/en/2.4.0/overview.html'
            }
          ]
        },
        {
          name: 'Dataset Management',
          description: 'Datasets can help data scientists access data quickly when developing algorithm and training models. They do not need to care about how to connect data sources and the differences of data access paths of various data sources, so as to improve their work efficiency.',
          image: 'assets/images/eap/Dataset_Management.png',
          list: [
            {
              name: 'Dataset Management Overview',
              url: '/docs/ai-analytics/en/2.4.0/dataset_management/dataset_overview.html'
            },
            {
              name: 'Creating a Dataset',
              url: '/docs/ai-analytics/en/2.4.0/dataset_management/creating_dataset.html'
            },
            {
              name: 'Managing Datasets',
              url: '/docs/ai-analytics/en/2.4.0/dataset_management/managing_dataset.html'
            },
            {
              name: 'Exploring Datasets',
              url: '/docs/ai-analytics/en/2.4.0/dataset_management/exploring_dataset.html'
            }
          ]
        },
        {
          name: 'AI Lab',
          description: 'With AI Lab, a model development environment that is integrated with the mainstream Jupyter Lab and MLflow, you can package machine learning models in diversified formats, perform visual comparison and selection of models, collaborate and share examples on-demand, and shorten the training cycle of complex models.',
          image: 'assets/images/eap/MI_Lab.png',
          list: [
            {
              name: 'AI Lab Overview',
              url: '/docs/ai-analytics/en/2.4.0/mi_lab/mi_lab_overview.html'
            },
            {
              name: 'Managing Notebook Instances',
              url: '/docs/ai-analytics/en/2.4.0/mi_lab/managing_notebook.html'
            },
            {
              name: 'Managing Model Code',
              url: '/docs/ai-analytics/en/2.4.0/mi_lab/integrating_with_git.html'
            },
            {
              name: 'Monitoring Notebook Instances',
              url: '/docs/ai-analytics/en/2.4.0/mi_lab/integrating_with_mlflow.html'
            }
          ]
        },
        {
          name: 'AI Hub',
          description: 'As a distribution center for AI assets, AI Hub provides a comprehensive AI asset registration, hosting, and versioning service for model developers, facilitating the efficient management of AI assets, and improving the overall efficiency of model engineering.',
          image: 'assets/images/eap/MI_Hub.png',
          list: [
            {
              name: 'AI Hub Overview',
              url: '/docs/ai-analytics/en/2.4.0/mi_hub/mi_hub_overview.html'
            },
            {
              name: 'Registering Models',
              url: '/docs/ai-analytics/en/2.4.0/mi_hub/registering_model.html'
            },
            {
              name: 'Managing Model Version Deployment Instances',
              url: '/docs/ai-analytics/en/2.4.0/mi_hub/version_deployment.html'
            },
            {
              name: 'Monitoring Model Production Indicators',
              url: '/docs/ai-analytics/en/2.4.0/mi_hub/monitoring_indicator.html'
            }
          ]
        },
        {
          name: 'AI Pipelines',
          description: 'Achieve end-to-end AI model life cycle management by designing and monitoring pipeline flows that automate the online deployment of machine learning algorithms. You can design a variety of machine learning task nodes according to your business needs, forming a closed-loop and continual machine learning deployment.',
          image: 'assets/images/eap/MI_Pipelines.png',
          list: [
            {
              name: 'AI Pipelines Overview',
              url: '/docs/ai-analytics/en/2.4.0/mi_pipelines/mi_pipeline_overview.html'
            },
            {
              name: 'Managing Experiments',
              url: '/docs/ai-analytics/en/2.4.0/mi_pipelines/creating_workflow.html'
            },
            {
              name: 'Developing Pipelines',
              url: '/docs/ai-analytics/en/2.4.0/mi_pipelines/developing_model.html'
            },
            {
              name: 'Operator Reference',
              url: '/docs/ai-analytics/en/2.4.0/mi_pipelines/calculator.html'
            }
          ]
        },
        {
          name: 'Resource Configuration',
          description: 'Provides centralized management of the configurations of computing resources, storage resources and the connections. It provides the fundamental connections and resources for services on the AI Studio, such as AI Lab, AI Hub, AI Pipelines, to facilitate the quick configuration of resources based on your needs for machine learning.',
          image: 'assets/images/eap/Resource_Configuration.png',
          list: [
            {
              name: 'Resource Configuration Overview',
              url: '/docs/ai-analytics/en/2.4.0/resource_configuration/resource_configuration_overview.html'
            },
            {
              name: 'Managing Storage',
              url: '/docs/ai-analytics/en/2.4.0/resource_configuration/managing_storage.html'
            },
            {
              name: 'Configuring Data Source Connection',
              url: '/docs/ai-analytics/en/2.4.0/resource_configuration/configuring_connection.html'
            }
          ]
        }        
      ]
    },
    {
      category: 'EnOS Administration',
      description: 'EnOS, an AIoT operating system from Univers that is missioned to enable enterprises and cities to accelerate digital transformation and ecosystem development. ',
      image: 'assets/images/EnOS_admin.png',
      url: '',
      item: [
        {
          name: 'Identity and Access Management',
          description: 'Provides user account life cycle management capabilities, where you can control access to resources managed through EnOS. You can centralize the management of user identities and permissions, thereby ensuring the security of your organization’s data.',
          image: 'assets/images/iam.png',
          list: [
            {
              name: 'IAM Overview',
              url: '/docs/enos/en/2.4.0/iam/iam_overview.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/enos/en/2.4.0/iam/concept/index.html'
            },
            {
              name: 'LDAP Federation',
              url: '/docs/enos/en/2.4.0/iam/ou_admin/ldap/index.html'
            }
          ]
        },
        {
          name: 'Single Sign-On Service',
          description: 'Implement a single sign-on service between EnOS and third-party applications by using mainstream standard protocols, solving the problem of having different identity authentication methods for different business applications of your organization.',
          image: 'assets/images/aep/Single_Sign-On_Service.png',
          list: [
            {
              name: 'Single Sign-On Overview',
              url: '/docs/sso/en/2.4.0/sso_overview.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/sso/en/2.4.0/sso_concept.html'
            }
          ]
        },
        {
          name: 'Resource Management',
          description: 'Provides on-demand management of your resource usages, where you can configure alarms based on resource usages, thereby improving the transparency and utilization of resources.',
          image: 'assets/images/resource.png',
          list: [
            {
              name: 'Resource Management on EnOS',
              url: '/docs/enos/en/2.4.0/resourcemanagement/overview.html'
            },
            {
              name: 'Resource Specifications',
              url: '/docs/enos/en/2.4.0/resourcemanagement/reference/index.html'
            },
            {
              name: 'Managing Resources',
              url: '/docs/enos/en/2.4.0/resourcemanagement/getstarted.html'
            }
          ]
        },
        {
          name: 'Metering Service',
          description: 'Provides multi-dimensional visualization of measurement data that is used by platform resources and services, enabling platform operators to evaluate the operational status of the platform and develop better operations strategy based on the data.',
          image: 'assets/images/metering.png',
          list: [
            {
              name: 'Metering Service Overview',
              url: '/docs/enos/en/2.4.0/metering/metering_overview.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/enos/en/2.4.0/metering/metering_concepts.html'
            }
          ]
        },
        {
          name: 'Audit Service',
          description: 'Supports auditing and monitoring of all user operations, user logins, and user logouts, and storing them as historical events in a traceable and unalterable format during the storage period. This helps to enforce data security and compliance for your organization.',
          image: 'assets/images/audit.png',
          list: [
            {
              name: 'Audit Service Overview',
              url: '/docs/enos/en/2.4.0/audit/audit_overview.html'
            },
            {
              name: 'Getting Started',
              url: '/docs/enos/en/2.4.0/audit/audit_gettingstarted.html'
            }
          ]
        },
        {
          name: 'Security',
          description: 'Learn about the security technologies built in EnOS.',
          image: 'assets/images/security_bw.png',
          list: [
            {
              name: 'Security Overview',
              url: '/docs/enos/en/2.4.0/security/security_overview.html'
            },
            {
              name: 'X.509 Certificate Service',
              url: '/docs/enos/en/2.4.0/security/x509_ca/index.html'
            },
            {
              name: 'Security Schemes',
              url: '/docs/enos/en/2.4.0/security/security_mechanisms.html'
            }
          ]
        }
      ]
    },
    {
      category: 'EnOS Operation',
      image: 'assets/images/OM.png',
      description: 'One-stop EnOS operation and maintenance (O&M) experience',
      item: [
        {
          name: 'Enterprise Operation Center',
          description: 'The Enterprise Operation Center is a service that provides a vertical O&M and monitoring system that covers IaaS, PaaS, and SaaS layers to ensure environment stability, reduce O&M costs, and improve the O&M efficiency of enterprises.',
          image: 'assets/images/aep/Application_Development_Basics.png',
          list: [
            {
              name: 'Enterprise Operation Center Overview',
              url: '/docs/eoc/en/2.4.0/about/overview.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/eoc/en/2.4.0/about/concept.html'
            },
            {
              name: 'Usage Scenarios',
              url: '/docs/eoc/en/2.4.0/about/use_scenario.html'
            }
          ]
        }
      ]
    }
  ]
};
